import { useState, useEffect } from "react";
import { useAuth } from "@/context/AuthContext";

const ONBOARDING_KEY = "tps_onboarding_completed";

export function useOnboarding() {
  const { user } = useAuth();
  const [showOnboarding, setShowOnboarding] = useState(false);

  useEffect(() => {
    if (!user) {
      setShowOnboarding(false);
      return;
    }

    // Check if user has completed onboarding
    const userOnboardingKey = `${ONBOARDING_KEY}_${user.id}`;
    const hasCompletedOnboarding = localStorage.getItem(userOnboardingKey);

    if (!hasCompletedOnboarding) {
      // Small delay to let the auth flow complete
      const timer = setTimeout(() => {
        setShowOnboarding(true);
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [user]);

  const completeOnboarding = () => {
    if (user) {
      localStorage.setItem(`${ONBOARDING_KEY}_${user.id}`, "true");
      setShowOnboarding(false);
    }
  };

  return {
    showOnboarding,
    completeOnboarding,
  };
}
